import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import TooltipIcon from './TooltipIcon';
import ReactTooltip from 'react-tooltip';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import {viewStyles} from '../shared/styles-view';

/**
 * Input fields
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) =>
    <TextField
        errorText={touched && error}
        {...inputProps}
        {...props}
    />;

/**
 * A component for editing Loyalty Account fields.
 *
 */
class LoyaltyAccountPointEdit extends Component {

    render() {

        const {
            isModal,
            onButtonClick,
            onFormChange
        } = this.props;

        const styles = {
            button: {display: 'inline-block', margin: '0 1em 0 0'},
            buttons: {display: 'block', margin: '0.5em 0 1em 0'}
        };

        return (
            <div className="loyalty-field-edit">
                <div>
                    <span style={viewStyles.fieldDescriptionTop}>
                        Adjust Rank Points and Reward Points. Enter values to add to or subtract from the
                        current totals. Do not enter new totals. If you do not wish to adjust Rank or Reward Points,
                        leave fields as <em>0</em>.
                        <TooltipIcon dataFor="ttRankReward"/>
                        <ReactTooltip id="ttRankReward" type="light" effect="solid" multiline={true} border={true}
                                      className="tooltip">
                            The Loyalty Customer's current <strong>Rank Points</strong>
                            and <strong>Reward Points</strong> are listed above. To adjust either total, modify the
                            fields below. Adjustments may be negative.
                            <br/><br/>
                            For example, if a Customer has 200 Reward Points and you want to add points to give them
                            a total of 240, enter <em>40</em> in the Reward Points field.
                            <br/><br/>
                            If a Customer has 200 Reward Points and you want to penalize them down to 120,
                            enter <em>-80</em> in the Reward Points field.
                            <br/><br/>
                            Modifying the Rank Points field may raise or lower the Customer to a new Rank.
                        </ReactTooltip>
                    </span>
                    <hr style={viewStyles.break}/>

                    <Field
                        name="rank_points"
                        type="number"
                        step={1}
                        component={renderInput}
                        onChange={(e) => onFormChange(e, 'rank_points')}
                        floatingLabelText="Rank Points"
                        style={viewStyles.rowShowField}
                    />
                    <Field
                        name="reward_points"
                        type="number"
                        step={1}
                        component={renderInput}
                        onChange={(e) => onFormChange(e, 'reward_points')}
                        floatingLabelText="Reward Points"
                        style={viewStyles.rowShowField}
                    />

                    <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

                    {isModal &&
                    <div style={styles.buttons}>
                        <RaisedButton
                            type="button"
                            primary
                            label="Complete Editing"
                            onClick={(e) => onButtonClick(e, 'submit')}
                            style={styles.button}
                        />
                        <RaisedButton
                            type="button"
                            label="Cancel"
                            onClick={(e) => onButtonClick(e, 'cancel')}
                            style={styles.button}
                        />
                    </div>
                    }

                </div>
            </div>
        )
    }
}

LoyaltyAccountPointEdit.propTypes = {
    formValues: PropTypes.object,
    isModal: PropTypes.bool,
    onButtonClick: PropTypes.func,
    onFormChange: PropTypes.func
};

LoyaltyAccountPointEdit.defaultProps = {
    formValues: {},
    isModal: false
};

const enhance = compose(
    connect()
);

export default enhance(LoyaltyAccountPointEdit);



// WEBPACK FOOTER //
// ./src/Fuse/components/LoyaltyAccountPointEdit.js